import React, { useEffect, useState } from "react";

const questionsData = [
  // ===== MCQ QUESTIONS =====
  {
    id: 1,
    type: "mcq",
    question: "What is the capital of India?",
    options: ["Delhi", "Mumbai", "Kolkata", "Chennai"],
  },
  {
    id: 2,
    type: "mcq",
    question: "Which of the following is NOT a JavaScript data type?",
    options: ["String", "Boolean", "Undefined", "Character"],
  },
  {
    id: 3,
    type: "mcq",
    question: "Which company developed React?",
    options: ["Google", "Facebook", "Microsoft", "Amazon"],
  },
  {
    id: 4,
    type: "mcq",
    question: "Which hook is used for state management in React?",
    options: ["useEffect", "useContext", "useState", "useReducer"],
  },
  {
    id: 5,
    type: "mcq",
    question: "Which keyword is used to declare a constant in JavaScript?",
    options: ["var", "let", "const", "static"],
  },

  // ===== WRITTEN / LONG QUESTIONS =====
  {
    id: 6,
    type: "written",
    question:
      "Explain the concept of React Hooks. Why were hooks introduced and what problems do they solve compared to class components?",
  },
  {
    id: 7,
    type: "written",
    question:
      "What is the Virtual DOM in React? Explain how it improves application performance.",
  },

  // ===== MCQ =====
  {
    id: 8,
    type: "mcq",
    question: "Which HTML tag is used to define an unordered list?",
    options: ["<ol>", "<ul>", "<li>", "<list>"],
  },
  {
    id: 9,
    type: "mcq",
    question: "Which HTTP method is used to update data?",
    options: ["GET", "POST", "PUT", "FETCH"],
  },
  {
    id: 10,
    type: "mcq",
    question: "Which operator is used for strict equality in JavaScript?",
    options: ["==", "=", "===", "!="],
  },

  // ===== LONG QUESTIONS =====
  {
    id: 11,
    type: "written",
    question:
      "Explain the complete lifecycle of a React component. Describe mounting, updating, and unmounting phases.",
  },
  {
    id: 12,
    type: "written",
    question:
      "What is REST API? Explain REST principles and HTTP status codes with examples.",
  },

  // ===== MCQ =====
  {
    id: 13,
    type: "mcq",
    question: "Which CSS property controls text size?",
    options: ["font-style", "text-size", "font-size", "text-style"],
  },
  {
    id: 14,
    type: "mcq",
    question: "Which browser has V8 JavaScript engine?",
    options: ["Firefox", "Safari", "Chrome", "Edge"],
  },
  {
    id: 15,
    type: "mcq",
    question: "Which of the following is a NoSQL database?",
    options: ["MySQL", "PostgreSQL", "MongoDB", "Oracle"],
  },

  // ===== LONG =====
  {
    id: 16,
    type: "written",
    question:
      "Explain the difference between SQL and NoSQL databases. Mention use cases of each.",
  },

  // ===== MCQ =====
  {
    id: 17,
    type: "mcq",
    question: "Which keyword is used to handle exceptions in JavaScript?",
    options: ["catch", "exception", "error", "handle"],
  },
  {
    id: 18,
    type: "mcq",
    question: "Which method converts JSON string to JavaScript object?",
    options: [
      "JSON.parse()",
      "JSON.stringify()",
      "JSON.convert()",
      "JSON.toObject()",
    ],
  },
  {
    id: 19,
    type: "mcq",
    question: "Which CSS layout is best for responsive design?",
    options: ["Float", "Table", "Flexbox", "Inline"],
  },
  {
    id: 20,
    type: "mcq",
    question: "Which command is used to install packages in npm?",
    options: ["npm add", "npm install", "npm get", "npm push"],
  },

  // ===== LONG =====
  {
    id: 21,
    type: "written",
    question:
      "What is authentication and authorization? Explain the difference with real-world examples.",
  },

  // ===== MCQ =====
  {
    id: 22,
    type: "mcq",
    question: "Which hook is used for side effects in React?",
    options: ["useState", "useMemo", "useEffect", "useRef"],
  },
  {
    id: 23,
    type: "mcq",
    question: "Which protocol is used for secure communication?",
    options: ["HTTP", "FTP", "HTTPS", "SMTP"],
  },
  {
    id: 24,
    type: "mcq",
    question: "Which language runs inside the browser?",
    options: ["Python", "Java", "C#", "JavaScript"],
  },
  {
    id: 25,
    type: "mcq",
    question: "Which tag is used to include JavaScript in HTML?",
    options: ["<js>", "<javascript>", "<script>", "<code>"],
  },

  // ===== LONG =====
  {
    id: 26,
    type: "written",
    question: "Explain the concept of closures in JavaScript with an example.",
  },
  {
    id: 27,
    type: "written",
    question: "What is Redux? Explain its core principles and data flow.",
  },

  // ===== MCQ =====
  {
    id: 28,
    type: "mcq",
    question: "Which array method is used to iterate over elements?",
    options: ["map()", "push()", "pop()", "slice()"],
  },
  {
    id: 29,
    type: "mcq",
    question: "Which keyword is used to export a module?",
    options: ["send", "export", "share", "module"],
  },
  {
    id: 30,
    type: "mcq",
    question: "Which function delays execution in JavaScript?",
    options: ["delay()", "timeout()", "setTimeout()", "wait()"],
  },

  // ===== LONG =====
  {
    id: 31,
    type: "written",
    question: "Explain event bubbling and event capturing in JavaScript.",
  },

  // ===== MCQ =====
  {
    id: 32,
    type: "mcq",
    question: "Which HTML attribute is used to define inline styles?",
    options: ["class", "style", "font", "css"],
  },
  {
    id: 33,
    type: "mcq",
    question: "Which React hook gives access to DOM elements?",
    options: ["useDom", "useRef", "useEffect", "useState"],
  },
  {
    id: 34,
    type: "mcq",
    question: "Which symbol is used for comments in JavaScript?",
    options: ["<!-- -->", "//", "**", "##"],
  },
  {
    id: 35,
    type: "mcq",
    question: "Which database uses collections?",
    options: ["MySQL", "MongoDB", "Oracle", "SQLite"],
  },

  // ===== LONG =====
  {
    id: 36,
    type: "written",
    question:
      "Explain client-side rendering vs server-side rendering. Which one is better and why?",
  },

  // ===== MCQ =====
  {
    id: 37,
    type: "mcq",
    question: "Which tool is used to manage versions of code?",
    options: ["Docker", "Git", "Jenkins", "NPM"],
  },
  {
    id: 38,
    type: "mcq",
    question: "Which tag is used to create a form?",
    options: ["<input>", "<form>", "<fieldset>", "<label>"],
  },
  {
    id: 39,
    type: "mcq",
    question: "Which React feature avoids unnecessary re-renders?",
    options: ["useState", "memo", "useEffect", "props"],
  },
  {
    id: 40,
    type: "mcq",
    question: "Which HTTP status code means Success?",
    options: ["404", "500", "200", "301"],
  },

  // ===== LONG =====
  {
    id: 41,
    type: "written",
    question: "Explain the concept of middleware in web applications.",
  },

  // ===== MCQ =====
  {
    id: 42,
    type: "mcq",
    question: "Which CSS unit is relative to parent element?",
    options: ["px", "em", "cm", "pt"],
  },
  {
    id: 43,
    type: "mcq",
    question: "Which keyword stops a loop?",
    options: ["exit", "stop", "break", "return"],
  },
  {
    id: 44,
    type: "mcq",
    question: "Which framework is used for backend JavaScript?",
    options: ["Angular", "React", "Vue", "Node.js"],
  },
  {
    id: 45,
    type: "mcq",
    question: "Which hook shares data across components?",
    options: ["useState", "useContext", "useRef", "useEffect"],
  },

  // ===== LONG =====
  {
    id: 46,
    type: "written",
    question:
      "What is CI/CD? Explain its importance in modern software development.",
  },

  // ===== MCQ =====
  {
    id: 47,
    type: "mcq",
    question: "Which command starts a React app?",
    options: ["npm start", "npm build", "npm run dev", "npm init"],
  },
  {
    id: 48,
    type: "mcq",
    question: "Which HTML tag is semantic?",
    options: ["<div>", "<span>", "<section>", "<b>"],
  },
  {
    id: 49,
    type: "mcq",
    question: "Which function converts object to JSON?",
    options: [
      "JSON.parse()",
      "JSON.stringify()",
      "JSON.convert()",
      "JSON.toString()",
    ],
  },

  // ===== FINAL LONG =====
  {
    id: 50,
    type: "written",
    question:
      "Describe the complete flow of a web request from browser to server and back to browser.",
  },
];

const OnlineTest = () => {
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState({});
  const [time, setTime] = useState(1800); // 30 minutes

  // Timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    const min = Math.floor(time / 60);
    const sec = time % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleOptionChange = (value) => {
    setAnswers({ ...answers, [currentQ]: value });
  };

  const handleSkip = () => {
    // Just move to next question
    setCurrentQ((prev) => (prev + 1 < questionsData.length ? prev + 1 : prev));
  };

  return (
    <>
            <div className="container-fluid mt-2">
              {/* Timer */}
              <div className="alert alert-primary text-center fw-bold">
                Time Remaining : {formatTime()}
              </div>

              <div className="row">
                 {/* Question Area */}
                <div className="col-md-9">
                  <div className="card">
                    <div className="card-body">
                      <h6 className="text-muted">
                        Question {currentQ + 1} of {questionsData.length}
                      </h6>
                      <h5 className="mt-2">
                        {questionsData[currentQ].question}
                      </h5>
                      <hr />

                      {/* MCQ */}
                      {questionsData[currentQ].type === "mcq" &&
                        questionsData[currentQ].options.map((opt, i) => (
                          <div className="form-check mb-2" key={i}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="option"
                              checked={answers[currentQ] === opt}
                              onChange={() => handleOptionChange(opt)}
                            />
                            <label className="form-check-label">{opt}</label>
                          </div>
                        ))}

                      {/* Written */}
                      {questionsData[currentQ].type === "written" && (
                        <textarea
                          className="form-control"
                          rows="5"
                          placeholder="Write your answer here..."
                          value={answers[currentQ] || ""}
                          onChange={(e) => handleOptionChange(e.target.value)}
                        />
                      )}

                      {/* Navigation Buttons */}
                      <div className="d-flex justify-content-between mt-4">
                        <button
                          className="btn btn-secondary"
                          disabled={currentQ === 0}
                          onClick={() => setCurrentQ(currentQ - 1)}
                        >
                          Previous
                        </button>

                        <div>
                          <button
                            className="btn btn-warning me-2"
                            onClick={handleSkip}
                          >
                            Skip
                          </button>

                          {currentQ === questionsData.length - 1 ? (
                            <button className="btn btn-danger">
                              Final Submit
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                setCurrentQ((prev) =>
                                  prev + 1 < questionsData.length
                                    ? prev + 1
                                    : prev
                                )
                              }
                            >
                              Save & Next
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Question List Panel */}
                <div className="col-md-3">
                  <div className="card">
                    <div className="card-header fw-bold">Questions</div>

                    <div
                      className="card-body"
                      style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                      }}
                    >
                      {questionsData.map((q, index) => (
                        <button
                          key={q.id}
                          className={`btn w-100 text-start mb-2 ${
                            currentQ === index
                              ? "btn-primary"
                              : answers[index]
                              ? "btn-success"
                              : "btn-outline-secondary"
                          }`}
                          onClick={() => setCurrentQ(index)}
                          title={q.question}
                        >
                          <strong>Q{q.id}.</strong>{" "}
                          {q.question.length > 40
                            ? q.question.substring(0, 40) + "..."
                            : q.question}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

               
              </div>
            </div>
    </>
  );
};
export default OnlineTest;
